import { Component, OnInit } from '@angular/core';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

// services
import { HelpService } from '@open-portal-app/help/services/help.service';

// constants
import { HELP_CONSTANTS } from '@open-portal-app/help/constants/help.constants';

@Component({
  selector: 'app-help-contact',
  templateUrl: './help-contact.component.html',
  styleUrls: ['./help-contact.component.scss']
})
export class HelpContactComponent implements OnInit {
  intent: any;
  companyInfo!: { [key: string]: any };
  title?: string;
  subTitle?: string;
  buttonText?: string;
  supportPhoneNumber?: string | number;
  infoList: any;

  constructor(
    public partnerBrandService: PartnerBrandService,
    private helpService: HelpService
  ) { }

  ngOnInit(): void {
    this.intent = this.helpService.helpflow.steps.find((steps: any) => steps.slug === 'customer-intent');
    this.setContent(this.intent && this.intent.answer);
  }

  setContent(intent: any) {
    // Charles Taylor contact number
    // Only travel claim support option leads to contact page
    const charleTaylorNumber = HELP_CONSTANTS.charlesTaylorNumber;
    // Collison for Smart Flight Delay
    const sfdNumber = HELP_CONSTANTS.sfdNumber;

    switch(intent) {
      case 'start-claim':
        this.title = 'We\'re here to help 24/7';
        this.subTitle = 'If you need to lodge a claim, call our claims team.';
        this.companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');
        this.buttonText = this.helpService.helpflow.selectedPolicyProductClass === 'travel' ? charleTaylorNumber : this.companyInfo.SUPPORT_PHONE;
        this.supportPhoneNumber = this.buttonText && this.buttonText.split(' ').join('');
        this.infoList = [
          { icon: 'management-documents', text: 'Your policy number', type: 'policy', policyNumber: this.helpService.helpflow.selectedPolicyNumber },
          { icon: 'communication-phone', text: 'Your best contact number' },
          { icon: 'management-emergencyhelp', text: 'The details of your claim' }
        ];
        break;
      case 'existing-claim':
        this.title = 'We\'re here to help 24/7';
        this.subTitle = 'If you need to speak to someone about your existing claim, call our claims team.';
        this.companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');
        this.buttonText = this.helpService.helpflow.selectedPolicyProductClass === 'travel' ? charleTaylorNumber : this.companyInfo.SUPPORT_PHONE;
        this.supportPhoneNumber = this.buttonText && this.buttonText.split(' ').join('');
        this.infoList = [
          { icon: 'management-documents', text: 'Your policy number', type: 'policy', policyNumber: this.helpService.helpflow.selectedPolicyNumber },
          { icon: 'management-claim', text: 'Your claim reference number' },
          { icon: 'management-emergencyhelp', text: 'The details of your claim' }
        ];
        break;
      case 'existing-flight':
        this.title = 'If you need 24/7 support with Smart Flight Delay';
        // Collison for Smart Flight Delay
        this.buttonText = sfdNumber;
        this.supportPhoneNumber = this.buttonText.split(' ').join('');
        this.infoList = [
          { icon: 'management-updateflightdetails', text: 'Your flight number' },
          { icon: 'management-updatetraveldates', text: 'Your departure date' },
          { icon: 'communication-email', text: 'The email address you used to register your flights' }
        ];
        break;
      default:
        this.title = 'We\'re here to help';
        this.subTitle = 'We\'re here to answer your questions, including about getting insurance, managing your policy or making a claim.';

        this.companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');
        this.buttonText = this.companyInfo.SUPPORT_PHONE;
        this.supportPhoneNumber = this.companyInfo.SUPPORT_PHONE.split(' ').join('');

        this.infoList = [
          { icon: 'management-documents', text: 'Your policy number', type: 'policy', policyNumber: this.helpService.helpflow.selectedPolicyNumber },
          { icon: 'communication-phone', text: 'Your best contact number' },
          { icon: 'marketing-optionals', text: 'Details about your query' }
        ];
        break;
    }
  }

  call() {
    window.location.href = `tel:${this.supportPhoneNumber}`
  }
}
